import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=61a5568c&scoped=true&"
import script from "./NotificationsTable.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTable.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=61a5568c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a5568c",
  null
  
)

export default component.exports